import { render } from "./Pagination2.vue?vue&type=template&id=2a97108b&scoped=true"
import script from "./Pagination2.vue?vue&type=script&lang=js"
export * from "./Pagination2.vue?vue&type=script&lang=js"

import "./Pagination2.vue?vue&type=style&index=0&id=2a97108b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a97108b"]])

export default __exports__